import { declineActionStyles } from '@/configuration/pages/ConfigurationPage/ReturnProtectionConfiguration/ReturnProtectionAppearanceConfiguration/WidgetAndPopupTab/constants'

const mapChangedValues = values => {
  const appearance = {
    widget_background_color: values.widget_background_color,
    widget_text_color: values.widget_text_color,
    widget_link_color: values.widget_link_color,
    popup_overlay_color: values.popup_overlay_color,
    popup_header_text_color: values.popup_header_text_color,
    popup_body_text_color: values.popup_body_text_color,
    decline_action_style: values.decline_action_style,
  }

  return Object.fromEntries(Object.entries(appearance).filter(([, value]) => value !== undefined))
}

const mapMultipartAppearance = (values, headerImage) => {
  const appearance = new FormData()

  Object.entries(values).forEach(([field, value]) => appearance.append(field, value))
  appearance.append('popup_header_image', headerImage)

  return appearance
}

export const transformResponseReturnProtectionAppearance = appearance => {
  return {
    widget_background_color: appearance.widget_background_color,
    widget_text_color: appearance.widget_text_color,
    widget_link_color: appearance.widget_link_color,
    popup_overlay_color: appearance.popup_overlay_color,
    popup_header_text_color: appearance.popup_header_text_color,
    popup_body_text_color: appearance.popup_body_text_color,
    popup_header_image_url: appearance.popup_header_image_url,
    decline_action_style: appearance.decline_action_style ?? declineActionStyles.button,
  }
}

export const transformRequestEditReturnProtectionAppearance = ({ storeId, values, headerImage }) => {
  const changedValues = mapChangedValues(values)

  if (!headerImage) return { storeId, appearance: changedValues }

  return { storeId, appearance: mapMultipartAppearance(changedValues, headerImage) }
}

export const transformRequestResetReturnProtectionWidget = ({ storeId }) => {
  return {
    storeId,
    appearance: {
      widget_background_color: null,
      widget_text_color: null,
      widget_link_color: null,
    },
  }
}

export const transformRequestResetReturnProtectionPopup = ({ storeId }) => {
  return {
    storeId,
    appearance: {
      popup_overlay_color: null,
      popup_header_text_color: null,
      popup_body_text_color: null,
      popup_header_image: null,
    },
  }
}
